module.exports = __webpack_public_path__ + "static/media/privacy-policy.63ece846.md";